import { spacingMixin } from '@zillow/constellation';
import styled from 'styled-components';

var Video = /*#__PURE__*/styled.video.withConfig({
  componentId: "sc-sjp072-0"
})(["display:block;", ""], spacingMixin);
var StyledVideo = Video;

export { StyledVideo as default };
